import { Component, OnInit, ViewChild } from '@angular/core';
import { PatientApi } from '@core/apis/patient/patient.api';
import { IChangePassword } from '@core/apis/patient/patient.interface';
import { ChangePasswordModalComponent } from '@core/components/change-password-modal/change-password-modal.component';
import { DashboardComponent } from '@core/components/dashboard/dashboard.component';
import { IUserStore } from '@core/interfaces/interface';
import { UserStore } from '@core/stores/user.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { navigationPatient } from '../../navigation';
import { UserTypeEnum } from '@oranta-mis/sdk';

@Component({
  selector: 'app-home',
  imports: [DashboardComponent, TranslocoModule, ChangePasswordModalComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
@UntilDestroy()
export class HomeComponent implements OnInit {
  protected readonly navigationPatient = navigationPatient.slice(1);
  @ViewChild(ChangePasswordModalComponent)
  orderModal!: ChangePasswordModalComponent;
  public isLoading: boolean = false;
  public closeDialog: boolean = false;

  public readonly UserTypeEnum = UserTypeEnum;
  constructor(
    private readonly userStore: UserStore,
    private readonly patientApi: PatientApi,
  ) {}
  public changePasswordModal() {
    this.orderModal.openModal();
  }
  public user: IUserStore | null = null;

  ngOnInit(): void {
    this.user = this.userStore.get();
    console.log(this.user);
  }

  public changePassword(form: IChangePassword) {
    this.patientApi
      .changePassword(form)
      .pipe(untilDestroyed(this))
      .subscribe({
        complete: () => {
          this.isLoading = false;
          this.orderModal.closeDialogModal();
        },
      });
  }
}
